import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

type SegmentTabsContextType<T = string> = {
  selectValue: T
  onTabChange: (value: T) => void
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SegmentTabsContext = createContext<SegmentTabsContextType<any> | null>(null)

export const useSegmentTabsContext = <T extends string>(): SegmentTabsContextType<T> => {
  const context = useContext(SegmentTabsContext)

  if (context === null) {
    throw new Error('useSegmentTabsContext must be used within a SegmentTabsProvider')
  }

  return context
}

export const SegmentTabsProvider = <T extends string>({ children, value }: PropsWithChildren & { value: SegmentTabsContextType<T> }) => {
  return <SegmentTabsContext.Provider value={value}>{children}</SegmentTabsContext.Provider>
}
